import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Toast, ToasterService, ToastType } from 'angular2-toaster';

@Injectable()
export class WrapToasterService {
	constructor(private readonly toasterService: ToasterService) {}

	public handleRequestFailed(response: HttpErrorResponse) {
		let body = response.error || '';
		body = body || JSON.stringify(body);

		if (body && body.error && body.error instanceof ErrorEvent) {
			this.showToast('error', 'Error', body.error.message);
		} else if (body && body['message'] && Array.isArray(body['message'])) {
			const message = body['message'].map((item) => item.message).join('; ');
			this.showToast('error', 'Error', message);
		} else if (body && body['message']) {
			this.showToast('error', 'Error', body['message']);
		} else {
			this.showToast('error', 'Error', 'Ooops, something went wrong...');
		}
	}

	public handleSuccessMessage(message: string) {
		if (!message) {
			return;
		}
		this.showToast('success', 'Success', message);
	}

	public handleErrorMessage(message: string) {
		this.showToast('error', 'Error', message);
	}

	public handleInfoMessage(message: string) {
		this.showToast('warning', 'Warning', message);
	}

	public showToast(type: ToastType, title: string, message: string) {
		const toast: Toast = {
			type,
			title,
			body: message,
			showCloseButton: true,
		};

		this.toasterService.pop(toast);
	}
}
